export default {
  client: {
    client: 'Contractor',
    clients: 'Contractors',
    clientAdd: 'Adding a new contractor',
    clientEdit: 'Editing contractor no. sys.',
    clientNew: 'New contractor',
    noClients: 'No contractors in the system',
    nip: 'VAT ID',
    pesel: 'PESEL',
    dealGroupNumber: 'Deal grouping',
    country: 'Country',
    place: 'City',
    postcode: 'Postal code',
    street: 'Street',
    numbers: 'Number',
    flat: 'Apartment',
    addressEx: 'Foreign address',
    isRelated: 'Related contractor (CIT)',
    internal: 'Internal to Group One (Accountancy)',
    notToSymphony: 'No export of purchase invoice (FVZ) to ERP/EOD',
    signContractBlock: 'Contract automatic send block',
    notSendMailFVS: 'Emails are not sent with FVS',
    symphony: 'Symphony',
    contacts: 'Contacts',
    languagePreference: 'Communication language',
    emailAddresses: 'Email addresses for FVS sending',
    address: 'Address',
    invoiceNumber: 'Invoice no.',
    enterNIP: 'Please enter VAT ID',
    additionalParams: 'Additional parameters',
    basicData: 'Basic data',
    notActivePurchasersPositions:
      'This inactive client has active purchasers or positions associated with it.',
    overduePaymentReminder: 'Overdue payment reminder',
    paymentRequest: 'Payment request',
    paymentRequestKRD: 'Payment request + National Debt Register warning',
    paymentRequestBlockKRD:
      'Payment request + account block and National Debt Register warning',
    interest: 'Interest',
    hasActivePurchaser: 'Purchaser',
    hasActivePosition: 'Position',
    automaticVindication: 'Automatic vindication',
    paymentRequestKRDfull:
      'Payment request with a warning about publishing the debt in the National Debt Register',
    paymentRequestBlockKRDFull:
      'Payment request with a warning about account block and publishing the debt in the National Debt Register',
    contactsTab: 'Clients contacts',
    clientContacts: 'Client contacts',
    withoutContactTab: 'Missing client contacts',
    contactsColumn: 'Contacts',
    surveyClientsList: 'Client list',
    noClientsWithoutContacts: 'No contractors without contact',
    contactType: 'Contact type',
  },
  purchaser: {
    purchaser: 'Purchaser',
    purchaserAdd: 'Adding a new purchaser',
    purchaserEdit: 'Editing purchaser no. sys.',
    purchaserNew: 'New purchaser',
    noPurchasers: 'No purchasers in the system',
    noPurchasersForClient: 'No purchasers for this contractor.',
    manager: 'Budget manager',
    addPurchaser: 'Add purchaser',
  },
  position: {
    position: 'Profile position',
    positions: 'Profile positions',
    positionsShortName: 'Positions',
    positionAdd: 'Adding a new profile position',
    positionEdit: 'Editing profile position no. sys.',
    positionNew: 'New profile position',
    noPositions: 'No profile positions in the system',
    noPositionsForClient: 'No profile positions for this contractor',
    chooseSpecialTeam: 'Please select a delivery team.',
    groupName: 'Group name',
    type: 'Position type',
    communicationCanal: 'Communication channel',
    specialTeams: 'Delivery teams',
    profilesEstimates: 'Mediaplan profiles',
    notPurchaseDeficiencies:
      'Not subject to purchase invoice (FVZ) deficiencies',
    profiles: 'Profiles',
  },
  budget: {
    budget: 'Budget',
    budgets: 'Budgets',
    budgetAdd: 'Adding a new budget',
    budgetEdit: 'Editing budget no. sys.',
    budgetNew: 'New budget',
    noBudgets: 'No budgets in the system',
    managerName: 'Budget manager',
    downloadDocuments: 'Bulk document download',
  },
  brand: {
    brand: 'Brand',
    brands: 'Brands',
    brandAdd: 'Adding a new brand',
    brandEdit: 'Editing brand no. sys.',
    brandNew: 'New brand',
    noBrands: 'No brands in the system',
    budget: 'Brand budget',
  },
  emailAddress: {
    add: 'Adding email addresses for FVS sending',
    edit: 'Editing email address for FVS sending',
    new: 'New email address for FVS sending',
    noEmailAddressForClient: 'No email addresses for this contractor',
    emailsTo: 'Email addresses for FVS sending',
    emailsDw: 'Email addresses for FVS sending (CC)',
    emailFrom: 'Email address from which invoices will be sent',
    comment: 'Comment',
  },
  contact: {
    add: 'Adding contact',
    edit: 'Editing contact',
    new: 'New contact',
    noContactsForClient: 'No contacts for this contractor',
    contactType: 'Contact type',
    email: 'Email',
    emailFallbackInfo:
      'If a specific contact type email is not available, the system will use the "General" type address.',
    selectContactType: 'Select contact type',
  },
  clientGroup: {
    clientGroups: 'Client groups',
    clientGroup: 'Client group',
    clientGroupNew: 'New group',
    clientGroupAdd: 'Adding new client group',
    clientGroupEdit: 'Edit client group',
    noClientGroups: 'No client groups in the system',
    noClientsInGroup: 'No clients added to the group',
    groupClients: 'Clients in group',
    addClients: 'Add clients',
    removeFromGroup: 'Remove from group',
    removeFromGroupConfirm:
      'Are you sure you want to remove the client from the group?',
    selectClients: 'Select clients to add',
    addClientsHint:
      'To add multiple clients, select them by clicking on the row. Selected clients will be highlighted in yellow. After saving, the selected clients (one or more) will be added to the group.',
    groupName: 'Group name',
    groupDescription: 'Description',
    groupMembership: 'Group membership',
    noGroupMembership: 'The client does not belong to any group',
    groupWithoutContactTab: 'Missing contacts in group',
  },
} as const;
